<template>
  <ValidationObserver
    ref="form"
    v-slot="{ invalid, handleSubmit, reset }"
  >
    <form
      autocomplete="off"
      @submit.prevent="handleSubmit(submit)"
      @reset.prevent="reset"
    >
      <modal
        v-model="modalOpened"
        :title="$t('cards.payments_history.download_receipt')"
        cancel-text=" "
        ok-text=" "
      >
        <ValidationProvider
          v-slot="{ errors }"
          rules="alpha_num|min:13|max:14"
          :name="$t('cards.payments_history.service_reference_id').toLowerCase()"
          vid="srid"
          slim
        >
          <div
            class="form-group"
            :class="{'has-error': errors.length}"
          >
            <label for="downloadReceiptSrfid">{{ $t('cards.payments_history.service_reference_id') }}</label>
            <PortalTooltip
              tip-id="sridHelp"
              :text="$t('login.create_account.hints.srid')"
              image="/img/hint-SRFID.png"
            />
            <input
              id="downloadReceiptSrfid"
              ref="srid"
              v-model="srid"
              name="download-receipt-srfid"
              class="form-control"
              type="text"
              :placeholder="$t('cards.payments_history.service_reference_id')"
            >
            <span
              v-if="errors.length"
              class="help-block"
              role="alert"
            >
              <i
                v-if="errors.length"
                class="fa fa-warning"
                role="alert"
              />{{ errors[0] }}
            </span>
          </div>
        </ValidationProvider>

        <div slot="footer">
          <button
            id="downloadReceiptBtn"
            class="btn btn-primary download2"
            type="submit"
            style="float: left;"
            :disabled="invalid || srid.length === 0 || receiptDownloading"
            :class="{'icon-left': !receiptDownloading}"
          >
            <span v-if="receiptDownloading">
              <DataLoadingSpin />
            </span>
            <span>
              {{ $t('cards.payments_history.download_receipt') }}
            </span>
          </button>
          <button
            id="closeDownloadReceiptModalBtn"
            class="btn btn-info"
            type="reset"
            @click="modalOpened=false"
          >
            {{ $t('uiv.modal.close') }}
          </button>
        </div>
      </modal>
    </form>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {alpha_num, max, min, length} from 'vee-validate/dist/rules'
import {Modal} from 'uiv'
import {Payments} from '@/api/PortalBackendService/passenger'
import PortalTooltip from '@/components/PortalTooltip'
import DataLoadingSpin from '@/components/DataLoading/DataLoadingSpin'
import json from '@/configuration.json'

extend('alpha_num', alpha_num)
extend('length', length)
extend('max', max)
extend('min', min)

export default {
  components: {Modal, PortalTooltip, ValidationObserver, ValidationProvider, DataLoadingSpin},
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      srid: '',
      modalOpened: false,
      receiptDownloading: false
    }
  },
  watch: {
    modalOpened(newValue) {
      this.$emit('input', newValue)
      if (newValue) {
        this.srid = ''
        setTimeout(() => {
          this.$refs.srid.focus()
        }, 300)
      }
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.modalOpened = newValue
      }
    }
  },
  methods: {
    submit() {
      this.receiptDownloading = true
      Payments.downloadReceipt(this.srid, undefined, '/receipts')
        .catch(({data}) => this.$notify(data, {
          type: 'warning',
          title: this.$root.$t('cards.payments_history.download_receipt'),
          content: this.$root.$t('cards.payments_history.download_receipt_failure'),
          duration: json.notification_duration.warning
        }))
        .finally(() => {
          this.receiptDownloading = false
        })
    }
  }
}
</script>
